import { render, staticRenderFns } from "./ReportsCommissionsCustomer.vue?vue&type=template&id=1153e036&scoped=true&"
import script from "./ReportsCommissionsCustomer.vue?vue&type=script&lang=js&"
export * from "./ReportsCommissionsCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ReportsCommissionsCustomer.vue?vue&type=style&index=0&id=1153e036&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1153e036",
  null
  
)

export default component.exports